/**
 * Cross-platform external URL opener.
 *
 * On iOS/Android (Capacitor): uses @capacitor/browser in default fullscreen
 *   mode → presents SFSafariViewController on iOS with native "Done" button.
 *
 * On web/preview: synthesises a real anchor click instead of window.open() —
 *   mobile Safari treats programmatic window.open() as same-tab navigation
 *   but respects a user-initiated click on an <a target="_blank"> element.
 */
import { isNative } from "./platform";

export async function openExternalUrl(url) {
  if (!url) return;
  if (isNative()) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url });
      return;
    } catch (e) {
      console.warn("[openExternalUrl] Browser.open failed:", e?.message || e);
    }
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
